import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_conversation_call_phone_auth')
@Index(['phoneNumber'])
@Index(['entity', 'entityId'])
export class ConversationCallPhoneAuthEntity extends BaseEntity {
	@Column({
		name: '_phone_number',
		type: 'varchar',
		length: 20,
		nullable: false,
		comment: 'Phone number in E.164 format (e.g., +12484796564)',
	})
	@Index()
	public phoneNumber!: string;

	@Column({
		name: '_pin',
		type: 'varchar',
		length: 255,
		nullable: true,
		comment: 'Hashed PIN code (bcrypt). Nullable for future non-PIN auth methods',
	})
	public pin?: string;

	@Column({
		name: '_entity',
		type: 'varchar',
		length: 50,
		nullable: true,
		comment: 'Entity type (user, client, vendor, etc.)',
	})
	public entity?: string;

	@Column({
		name: '_entity_id',
		type: 'int',
		unsigned: true,
		nullable: true,
		comment: 'Foreign key to the entity (user ID, client ID, etc.)',
	})
	public entityId?: number;

	@Column({
		name: '_is_active',
		type: 'boolean',
		default: true,
		comment: 'Whether this auth record is active',
	})
	public isActive!: boolean;

	@Column({
		name: '_failed_attempts',
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Number of consecutive failed authentication attempts',
	})
	public failedAttempts!: number;

	@Column({
		name: '_locked_until',
		type: 'timestamp',
		nullable: true,
		comment: 'Timestamp until which the account is locked due to failed attempts',
	})
	public lockedUntil?: Date;

	@Column({
		name: '_last_failed_attempt',
		type: 'timestamp',
		nullable: true,
		comment: 'Timestamp of the last failed authentication attempt',
	})
	public lastFailedAttempt?: Date;
}
